import { connect } from 'react-redux';
import { Store, asyncActions, searchParameterActions } from "dw_azsearchstore";
import * as redux from "redux";
import { SearchParametersAction } from 'dw_azsearchstore/dist/actions/searchParametersActions';
import Sortbox from "../components/sortbox/Sortbox";

function getReturnType<RT>(expression: (...params: any[])=>RT): RT {
    return {} as RT;
}        

function mapStateToProps(state: Store.SearchState) {
    return {
        results: state.results.results,
        total: state.results.count,
    }
}

const mapDispatchToProps = (dispatch: redux.Dispatch<SearchParametersAction>) => {
    return{
        addSorter: (sorterKey: string, sorterDirection: string) => {
            dispatch(searchParameterActions.updateSearchParameters({orderby: `${sorterKey} ${sorterDirection}`}));
            dispatch(asyncActions.fetchSearchResultsFromFacet);
            window.scrollTo({top: 0, behavior: "smooth"});
        },
        removeSorter: () => {
            dispatch(searchParameterActions.updateSearchParameters({orderby: ""}));
            dispatch(asyncActions.fetchSearchResultsFromFacet);
            window.scrollTo({top: 0, behavior: "smooth"});
        }
    }
}

export const stateProps = getReturnType(mapStateToProps);
export const dispatchProps = getReturnType(mapDispatchToProps);

export type PropsType = typeof stateProps & typeof dispatchProps;
type State = {};

const SortboxContainer = connect(mapStateToProps, mapDispatchToProps)(Sortbox);

export {SortboxContainer};